import styled from '@emotion/styled';
import { NavLink } from 'react-router-dom';

export const Actions = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;

export const Track = styled.div`
  display: flex;
  width: 100%;
  min-height: 54px;
  justify-content: space-between;
  align-items: center;
  padding: 16px 30px 16px 70px;
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out, transform 0.3s ease-in-out;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const Column = styled.div`
  font-weight: 300;
  flex: ${({ flex }) => flex};
  text-align: ${({ right }) => (right ? 'right' : 'left')};
`;

export const NoContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  width: 100%;
`;

export const Link = styled(NavLink)`
  color: #000;
`;
